import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';

export const VerticalRule = styled.hr`
    border: 0.5px solid ${colors.neutralLight20};
    margin: 0 ${sizes.medium}px;
`;
